<script>
export default {
  methods: {
    handleTopOver() {
      if (this.headerTopLine === 'basic') {
        this.headerTopLine = 'burger';
      }
    },
    handleTopLeave() {
      if (this.headerTopLine === 'burger') {
        this.headerTopLine = 'basic';
      }
    },
    handleBottomOver() {
      if (this.handleBottomOver) {
        if (this.headerBottomLine === 'basic') {
          this.headerBottomLine = 'burger';
        }
      }
    },
    handleBottomLeave() {
      if (this.headerBottomLine === 'burger' && this.headerTopLine !== 'menu') {
        this.headerBottomLine = 'basic';
      }
    },
    openTopMenu() {
      if (
        this.headerTopLine === 'menu' &&
        event.target !== '.section-menu__item'
      ) {
        this.headerTopLine = 'basic';
        this.headerBottomLine = 'basic';
      } else if (
        this.headerTopLine === 'basic' ||
        this.headerTopLine === 'burger' ||
        (this.headerTopLine === 'basic-large' &&
          this.headerBottomLine === 'menu-auto')
      ) {
        this.headerTopLine = 'menu';
        this.headerBottomLine = 'burger';
      }
    },
    openBottomMenu() {
      if (
        this.headerBottomLine === 'menu-auto' &&
        event.target !== '.sub-section-menu__item'
      ) {
        this.headerTopLine = 'basic';
        this.headerBottomLine = 'basic';
      } else if (
        this.headerBottomLine === 'basic' ||
        this.headerBottomLine === 'burger'
      ) {
        this.choosenMenuName = this.$store.getters.activeSection.name;
        this.choosenSubmenuItems = this.$store.getters.activeSection.subsections;
        this.headerTopLine = 'basic-large';
        this.headerBottomLine = 'menu-auto';
      }
    },
    navigateBottomMenu(event) {
      this.choosenMenuName = event.item.name;
      this.choosenSubmenuItems = event.item.subsections;
      this.headerTopLine = 'basic-large';
      this.headerBottomLine = 'menu-auto';
      this.$store.commit('setHeaderStatus', 'basic');
    }
  }
};
</script>
